import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {Select, Input, Pagination, Button, Popover, Tooltip, message, Modal, Menu, Dropdown, Icon} from 'antd';
import BaseTable from "../../components/baseTable/BaseTable";
import moment from "moment";
import {Scrollbars} from "react-custom-scrollbars";
import DeptTree from "../../contentSecurityCenter/components/DeptTree";
import OtherRenderPicker from "./component/otherRenderPicker";
import MediaList from "../../newsContribute/component/modal/mediaList";
import {HEADER_HEIGHT} from "../../../constants";


const {Option} = Select;
const {Search} = Input;

class OtherMediaManuscript extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};
    currentUserMediaList = [];
    constructor(props) {
        super(props);
        this.state = {
            value:'',
            count: 30,
            page: 1,
            otherMediaList: [],
            size: 10,
            mediaType: '',//默认是网站类型
            config: [],//配置项
            deptId: '',
            publishMediaListModalVisible: false, // 查看发布弹窗
            publishMediaListData: [], // 发布链接列表
            currentMedia: {},
            pickupData: {},//拾取至的数据
        };
        //初始化当前媒体，因为需要判断当前用户是否有该稿件投向的媒体的权限，如果没有，则点击进去后不能显示任何按钮
        this.getCurrentUserMediaList();
    }

    componentDidMount() {

        let config = JSON.parse(this.sysConfigGetValueByKey("other.media.manuscript.mediatype", []))
        console.log("config===============",config)
        this.setState({
            config,
            currentMedia: config[0],
            mediaType:config[0].mediaTypeCode
        }, () => {
            this.getOtherMediaList()
        })

    }

    getOtherMediaList = () => {
        this.request({
            url: '/cm-sites-pms/mediaNews/list',
            method: 'get',
            body: {
                page: this.state.page,
                size: this.state.size,
                keywords: this.state.value,
                mediaType: this.state.mediaType,
                deptId: this.state.deptId
            },
            contentType: 'json',
            callBack: (res) => {
                if(res&&res.data){
                    let list = [];
                    let count = 0
                    if (res && res.data && res.data.length) {
                        list = res.data
                        count = res.count
                    }
                    this.setState({otherMediaList: list, count}, () => {
                    })
                }
            }
        })
    }

    render() {
        return (
            <div style={{backgroundColor: "#fff", margin: 15, borderRadius: 5, maxHeight: "calc(100vh - 100px)"}}>
                {/*功能导航栏*/}
                {this.renderManuscriptNav()}
                {/*  表格  */}
                {this.renderTable()}
                {/*  分页 */}
                <div style={{
                    borderTop: this.state.count > 0 ? '1px solid #e8e8e8' : '',
                    height: 80,
                    paddingRight: 30,
                    paddingTop: 4,
                    paddingBottom: 4,
                    // display:this.state.otherMediaList&&this.state.otherMediaList.length>0?'block':'none'
                }}>
                    {this.state.count > 0 ?
                        <Pagination style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: 24
                        }}
                                    showTotal={(total) => `共有${total}条数据`} showSizeChanger showQuickJumper
                                    current={this.state.page} onChange={this.onPageChange}
                                    onShowSizeChange={this.onShowSizeChange} total={this.state.count}/>
                        : null}
                </div>
                {/*  查看发布 */}
                {this.renderViewPublishModal()}
            </div>
        )
    }

    renderManuscriptNav = () => {
      let data =this.state.config[0]?.mediaTypeName;
      
        return (
            <div id={'manuscript'} style={{padding: '24px 0px 24px 30px', display: "flex", flexWrap: "nowrap"}}>
                <div style={{ flex: "1 1 224px", maxWidth: "224px"}}>
                    {/*  部门下拉框  */}
                    <DeptTree
                        // disabled={this.DeptTree.disabled}
                        ref={ref => this.DeptTree = ref}
                        deptIdsCall={(deptValue, deptId) => this.deptSelect(deptValue, deptId)}
                    >
                    </DeptTree>
                </div>

                <div style={{ flex: "1 1 224px", maxWidth: "224px"}}>
                    {/*  媒体类型下拉框  */}
                    <Select
                        value={this.state.currentMedia.mediaTypeCode}
                        onChange={(value) => this.onMediaTypeChange(value)}
                        style={{width: '224px', marginLeft: -12, marginRight: 10}}>
                        {this.state.config && this.state.config.length && this.state.config.map((item, index) => {
                            return (
                                <Option value={item.mediaTypeCode} key={index}>{item.mediaTypeName}</Option>
                            )
                        })}
                    </Select>
                </div>
                <div style={{ flex: "1 1 224px", maxWidth: "224px"}}>
                    {/*  搜索框  */}
                    <Search
                        allowClear
                        value={this.state.value}
                        placeholder="请输入关键词"
                        onSearch={value => this.onSearch(value)}
                        style={{width: 250}}
                        onChange={e => {
                            this.setState({value:e.target.value})
                        }}
                    />
                </div>
                <style>
                    {`
                        #manuscript .ant-select-enabled .ant-select-selection{background:#f5f8fc}
                        #manuscript .ant-input-search .ant-input{background:#f5f8fc}
                    `}
                </style>
            </div>
        )
    };


    //渲染稿件列表
    renderTable = () => {
        let tableHeight=window.innerHeight - HEADER_HEIGHT - 101 - 20 - 81 - 15 - 15 - 20;
        let {otherMediaList} = this.state;
        return (
            <div id={'otherMediaList'} style={{padding: '20px 30px 0 30px', borderTop: '1px solid #e8e8e8'}}>
                <Scrollbars
                    autoHeight
                    autoHeightMax={"calc(100vh - 280px)"}
                >
                    <BaseTable
                        size={"default"}
                        columns={this.getColumns()}
                        dataSource={otherMediaList}
                        rowKey={"id"}
                    />
                </Scrollbars>
            </div>

        )
    }

    //获取表格列表
    getColumns = () => {
        return (
            [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    width: "330px",
                    ellipsis: {
                        showTitle: false,
                    },
                    render: (text, record) => {
                        let title = text;
                        return (
                            <div style={{cursor: "pointer"}}>
                                {/*点击跳转*/}
                                <Tooltip placement={"topLeft"} title={title}>
                                    <div
                                        style={{
                                            // maxWidth:'calc( 100% - 32px )',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                        onClick={() => {
                                            this.toPreview(record)
                                        }
                                        }
                                    >{title}</div>
                                </Tooltip>
                            </div>
                        )
                    }
                },
                {
                    title: '发布媒体',
                    dataIndex: 'mediaName',
                    key: 'mediaName',
                    width: 280,
                    ellipsis: {
                        showTitle: false,
                    },
                    render: (text, record) => {
                        return (
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img src={record.mediaLogo} style={{width: 30, height: 30, marginRight: 10}}/>
                                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',}} title={text}>{text}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '发布单位',
                    dataIndex: 'deptName',
                    key: 'deptName',
                    width: 100,
                    ellipsis: true,
                    render: (text, record) => {
                        return text
                    }
                },
                {
                    title: '发布人',
                    dataIndex: 'publisher',
                    key: 'publisher',
                    width: 100,
                    ellipsis: {
                        showTitle: false,
                    },
                    render: (text, record) => {
                        let txt = text;
                        if(txt&&txt.length>4) {
                            txt = txt.substring(0,4)+"..."
                        }
                        return  <div title={text}>{txt} </div>
                    }
                },
                {
                    title: '发布时间',
                    dataIndex: 'publishDate',
                    key: 'publishData',
                    width: 180,
                    render: (text, record) => {
                        let time = text ? moment(text).format('YYYY-MM-DD HH:mm') : '';
                        return time
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'entityId',
                    key: 'entityId',
                    width: '250px',
                    render: (text, record) => {
                        let btns = [];

                        // downloadBtn  Start
                        let downloadBtn = <Button style={{marginLeft: -8}} key={"downloadBtn"} size={'small'}
                                                  type={'link'} onClick={() => {
                            this.download(record)
                        }}>下载</Button>;
                        btns.push(downloadBtn);
                        // downloadBtn  end

                        // publishBtn  Start
                        if (this.state.currentMedia.showPublishBtn) {
                            let otherBtn = <Button key={"otherBtn"} size={'small'} type={'link'} className='aPopover'
                                                   style={{background: "unset"}} onClick={() => {
                                this.getPublishList(record.entityId)
                            }}>查看发布</Button>;
                            btns.push(otherBtn);
                        }
                        // publishBtn  end

                        // storyPicker  Start
                        let storyPicker = <Popover key={"storyPicker"}
                            // content={this.renderPicker({id:record.id,data:record})}
                                                   content={<OtherRenderPicker id={record.entityId} record={record}
                                                                               currentMedia={this.state.currentMedia}
                                                                               data={this.state.pickupData}
                                                                               treeData={this.state.treeData}/>}
                                                   placement="bottomRight"
                        >
                            <Button size={'small'} type={'link'} className='aPopover'
                                    style={{background: "unset"}}>拾取至</Button>
                        </Popover>;
                        btns.push(storyPicker);
                        // storyPicker  end

                        return (
                            <div>
                                {
                                    btns && btns.length ? (
                                        btns.map((btn, index) => {
                                            if (index < 3) {
                                                return btn
                                            }
                                            if (index === 3) {
                                                let menus = btns.slice(3, btn.length);
                                                menus = (
                                                    <Menu>
                                                        {
                                                            menus.map((menu, Index) => (
                                                                <Menu.Item key={Index}>
                                                                    {menu}
                                                                </Menu.Item>
                                                            ))
                                                        }
                                                    </Menu>
                                                );
                                                return (
                                                    <Dropdown overlay={menus} placement="bottomLeft" key={index}>
                                                        <Icon type="ellipsis"/>
                                                    </Dropdown>
                                                )
                                            }
                                        })
                                    ) : null
                                }
                            </div>
                        )
                    }
                }
            ]
        )
    }

    /**
     * 文章下载fun
     * 这里的record勿动，是当前这条数据
     * */
    download(record) {
        let {currentMedia} = this.state;
        let {download} = currentMedia;
        let url = download.url;
        let params = download.params;
        let body = {};
        try {
            for (let i in params) {
                body[i] = eval(params[i]);
            }
            this.request({
                url,
                body,
                method: "downloadPost"
            });
        } catch (e) {
            console.log(e.toString())
        }
    };


    /**
     * 点击标题预览稿件
     * record勿动
     * */
    toPreview(record) {
        let {currentMedia} = this.state;
        let {toPreview} = currentMedia;
        let checkUrl = {};
        let checkAll = {checkUrl};
        try {
            for (let i in toPreview.checkUrl) {
                checkUrl[i] = eval(toPreview.checkUrl[i])
            }
            for (let j in toPreview.checkAll) {
                checkAll[j] = eval(toPreview.checkAll[j])
            }
            window.openPage({
                url: "/cm-sites/pms/framereact/index.html#/view/otherMediaManuscript/details",
                params: {
                    checkUrl: checkUrl,
                    checkAll: checkAll,
                },
            })
        } catch (e) {
            console.log(e.toString())
        }

    }


    //查看发布
    getPublishList = (webNewsId) => {
        this.request({
            url: "/cm-sites-pms/website/news/getPublishUrl",
            body: {webNewsId},
            callBack: (data) => {
                console.log(data)
                let convertData = () => {
                    let group = [];
                    let names = [];
                    for (let i = 0; data && i < data.length; i++) {
                        let item = data[i];
                        if (item.mediaType) {
                            let index = names.indexOf(item.mediaType);
                            if (index === -1) {//不存在
                                if (!item.contentName) {
                                    group.push({
                                        icon: item.mediaLogoUrl,
                                        type: item.mediaType,
                                        data: [{href: item.linkUrl, name: item.mediaName}]
                                    });
                                } else {
                                    group.push({
                                        icon: item.mediaLogoUrl,
                                        type: item.mediaType,
                                        data: [{href: item.linkUrl, name: item.mediaName + "/" + item.contentName}]
                                    });
                                }
                                names.push(item.mediaType);
                            } else {
                                if (!item.contentName) {
                                    group[index].data.push({
                                        href: item.linkUrl,
                                        name: item.mediaName
                                    });
                                } else {
                                    group[index].data.push({
                                        href: item.linkUrl,
                                        name: item.mediaName + "/" + item.contentName
                                    });
                                }
                            }
                        }
                    }
                    return group;
                };
                let publishMediaListData = convertData();
                this.setState({publishMediaListModalVisible: true, publishMediaListData})
            }
        })
    };
    renderViewPublishModal = () => {
        return (
            <Modal
                title={"查看发布"}
                footer={null}
                visible={this.state.publishMediaListModalVisible}
                onOk={() => {
                    this.setState({publishMediaListModalVisible: false})
                }}
                onCancel={() => {
                    this.setState({publishMediaListModalVisible: false})
                }}
            >
                <Scrollbars
                    autoHeight={true}
                    autoHeightMax={500}
                    autoHide={true}
                >
                    <MediaList group={this.state.publishMediaListData} showHref={true}/>
                </Scrollbars>
            </Modal>
        )
    };


    //分页
    onPageChange = (page) => {
        this.setState({page}, () => {
            this.getOtherMediaList()
        })
    }
    //改变每页展示条数
    onShowSizeChange = (current, pageSize) => {
        this.setState({size: pageSize, page: 1,}, () => {
            this.getOtherMediaList()
        })
    }

    //搜索
    onSearch(value) {
        this.setState({
            page: 1,
            value,
        }, () => {
            this.getOtherMediaList()
        })
    }

    //媒体类型改变
    onMediaTypeChange(value) {
        let currentMedia = this.state.config.find((item) => {
            if (item.mediaTypeCode == value) {
                return item
            }
        })
        this.setState({
            page: 1,
            mediaType: value,
            currentMedia
        }, () => {
            this.getOtherMediaList()
        })
    }

    //部门改变
    deptSelect(deptValue, deptId) {
        console.log(deptValue, deptId)
        if (deptId == undefined) {
            this.setState({
                page: 1,
                deptId: ''
            }, () => {
                this.getOtherMediaList()
            })
        } else {
            this.setState({
                page: 1,
                deptId
            }, () => {
                this.getOtherMediaList()
            })
        }

    }

    getCurrentUserMediaList = ()=>{
        this.request({
            url : "/cm-sites-pms/media/getCurrentUserMediaGroupByType",
            callBack: (data)=>{
                // 过滤禁用的媒体
                let newData = data && data.map(item=>({
                    ...item,
                    mediaList: item.mediaList && item.mediaList.filter(media=>{
                        return  media.disable == 0;
                    })
                }));
                newData && newData.map(item=>{
                    item && item.mediaList && item.mediaList.map(media=>{
                        this.currentUserMediaList.push(media);
                    });
                });
                // 素材中心这里只保留网站和微信稿件
                if(newData){
                    let mediaTypes = this.sysConfigGetValueByKey("shiqu.media.type", "webNews,material").split(",");
                    newData = newData.filter(item=>{
                        return mediaTypes.indexOf(item.mediaTypeCode) > -1;
                    });
                }
                this.setState({
                    treeData: newData
                });
            }
        })
    };

}

export default OtherMediaManuscript;